import React, { Component } from 'react';

class ErrorBoundary extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false,
            error: null,
            errorInfo: null,
        };
    }

    static getDerivedStateFromError(error) {
        return { hasError: true };
    }

    componentDidCatch(error, errorInfo) {
        console.error("ErrorBoundary caught an error:", error, errorInfo);
        this.setState({
            error: error,
            errorInfo: errorInfo,
        });
    }

    render() {
        if (this.state.hasError) {
            return (
                <div className={"container"}>
                    <div className={"p-4 mt-3"} style={{
                        backgroundColor: '#f2c8c8',
                        borderRadius: '12px',
                        fontSize: '18px',
                        fontWeight: 400,
                        color: '#843232',
                        textAlign: 'center',
                    }} role="alert">
                        Something went wrong. We're working on fixing the issue.
                    </div>
                </div>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;